module.exports = __webpack_public_path__ + "static/media/rule_of_noun_accent_img.b4182771.JPG";